import { render, staticRenderFns } from "./horizontal-topbar.vue?vue&type=template&id=7855a9c0"
import script from "./horizontal-topbar.vue?vue&type=script&lang=js"
export * from "./horizontal-topbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports